import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'


const MapboxLoader = ({ onLoad, isMapboxLoading, setMapboxLoading }) => {
  const [isLoaded, setLoaded] = useState(false)
  useEffect(() => {
    if(!isLoaded && window.mapboxgl) {
      onLoad()
      setLoaded(true)
      return
    }

    const script = document.createElement('script')
    script.src = 'https://api.mapbox.com/mapbox-gl-js/v2.14.0/mapbox-gl.js'
    script.async = true
    script.onload = () => {
      if(!isLoaded) {
        onLoad()
        setLoaded(true)
      }
      setMapboxLoading(false)
    }
    if(!isMapboxLoading && !window.mapboxgl) document.body.appendChild(script)
    setMapboxLoading(true)
  }, [onLoad, isMapboxLoading])

  return null
}


MapboxLoader.propTypes = {
  onLoad: PropTypes.func,
  isMapboxLoading: PropTypes.bool,
  setMapboxLoading: PropTypes.func,
}

export default MapboxLoader
